<script setup lang="ts"></script>

<template>
  <h2 class="text-balance text-xl font-semibold tracking-tight text-zinc-300 sm:text-2xl">
    <slot />
  </h2>
</template>
